module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1038-b5b71657474847bda02c9565bf199591.png";